import { render, staticRenderFns } from "./newVulnerabilityList.vue?vue&type=template&id=0dedc6a1&scoped=true"
import script from "./newVulnerabilityList.vue?vue&type=script&lang=js"
export * from "./newVulnerabilityList.vue?vue&type=script&lang=js"
import style0 from "./newVulnerabilityList.vue?vue&type=style&index=0&id=0dedc6a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedc6a1",
  null
  
)

export default component.exports